import React from 'react';
import { FadeIn } from './FadeIn';
import { MicroscopeIcon, QuoteIcon } from 'lucide-react';
export function Chapters() {
  return <section className="py-12 md:py-24 bg-forest" data-id="element-94">
      <FadeIn className="container mx-auto px-5 max-w-[1200px]" data-id="element-95">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20" data-id="element-96">
          {/* Left: Image Card */}
          <div className="flex-1 w-full relative" data-id="element-97">
            <div className="relative aspect-square md:aspect-[4/5] rounded-[2rem] overflow-hidden border border-cream/10 shadow-2xl" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/mVhrN8WXaMFVYUZJUNDWHn/ChatGPT_Image_8_jun_2026,_13_31_46.png" alt="Jengibre, cúrcuma y tintura antiinflamatoria" className="w-full h-full object-cover" data-id="element-99" />
              {/* Gradient overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/20 to-transparent" data-id="element-100"></div>

              {/* Quote overlay */}
              <div className="absolute bottom-0 left-0 p-8 md:p-10 w-full" data-id="element-101">
                <QuoteIcon className="w-8 h-8 text-peach/80 mb-4" data-id="element-102" />
                <p className="font-serif italic text-xl md:text-2xl text-cream leading-snug" data-id="element-103">
                  "Al sanar tu barrera intestinal, reduces la carga inflamatoria
                  y tu cuerpo empieza a autorregularse."
                </p>
              </div>
            </div>

            {/* Badge */}
            <div className="absolute -top-4 -right-4 md:top-8 md:-right-8 bg-peach text-forest font-bold text-xs tracking-widest uppercase py-2 px-6 rounded-full transform rotate-3 shadow-lg border-2 border-forest" data-id="element-104">
              Antiinflamatorios
            </div>
          </div>

          {/* Right: Text Content */}
          <div className="flex-1 w-full" data-id="element-105">
            <span className="text-peach text-xs font-bold tracking-[0.2em] uppercase mb-4 md:mb-6 block" data-id="element-106">
              Capítulo 1 · La raíz del endodolor
            </span>

            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-6 md:mb-8 leading-tight" data-id="element-107">
              La conexión <span className="italic text-peach" data-id="element-108">Intestino</span> ·{' '}
              <span className="italic text-peach" data-id="element-109">Endometrio</span> ·{' '}
              <span className="italic text-peach" data-id="element-110">Inflamación</span>
            </h2>

            <div className="space-y-6 text-sand text-lg leading-relaxed mb-10" data-id="element-111">
              <p data-id="element-112">
                Lo que sucede en tu vientre no es un evento aislado. Es el
                resultado de un diálogo constante entre tu sistema digestivo, tu
                sistema inmunológico y tu equilibrio hormonal: el eje
                Intestino-Endometrio.
              </p>
              <p data-id="element-113">
                Cuando el intestino está en desequilibrio, se convierte en una
                fuente constante de mensajes que mantienen tu cuerpo en{' '}
                <em className="italic text-cream" data-id="element-114">alerta máxima</em>,
                amplificando el dolor y el crecimiento del tejido endometrial.
              </p>
            </div>

            <div className="inline-flex items-center gap-3 border border-cream/20 rounded-full py-3 px-6 text-sm text-sand/90" data-id="element-115">
              <MicroscopeIcon className="w-5 h-5 text-peach" data-id="element-116" />
              <span data-id="element-117">Basado en investigación clínica actualizada</span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}